import { render, staticRenderFns } from "./article-detail.vue?vue&type=template&id=28213508&scoped=true&"
import script from "./article-detail.vue?vue&type=script&lang=js&"
export * from "./article-detail.vue?vue&type=script&lang=js&"
import style0 from "./article-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./article-detail.vue?vue&type=style&index=1&id=28213508&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28213508",
  null
  
)

export default component.exports